import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=b1ab9d5c&scoped=true&"
import script from "./RegisterResult.vue?vue&type=script&lang=js&"
export * from "./RegisterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab9d5c",
  null
  
)

export default component.exports